import { Exclude, Expose, Transform, Type } from "class-transformer";
import { IsBoolean, IsDate, IsDefined, IsString } from "class-validator";

import { MangopayAddress } from "./Address";
import { Birthplace } from "./Birthplace";

@Exclude()
export class UBO {
    @IsDefined()
    @IsString()
    @Expose()
    public id?: string;

    @IsDefined()
    @IsString()
    @Expose()
    public firstName: string;

    @IsDefined()
    @IsString()
    @Expose()
    public lastName: string;

    @IsDefined()
    @Expose()
    @Type(() => MangopayAddress)
    public address: MangopayAddress = new MangopayAddress();

    @IsDefined()
    @IsString()
    @Expose()
    public nationalityCountryISOCode: string;

    @IsDefined()
    @IsDate()
    @Expose()
    @Type(() => Date)
    @Transform((value) => (value === undefined ? undefined : new Date(value)))
    public birthdayAt: Date;

    @IsDefined()
    @Expose()
    @Type(() => Birthplace)
    public birtplace: Birthplace = new Birthplace();

    @IsDefined()
    @IsBoolean()
    @Expose()
    public isActive?: boolean;
}
